/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UnassignTeamMemberBody
 */
export interface UnassignTeamMemberBody {
  /**
   *
   * @type {string}
   * @memberof UnassignTeamMemberBody
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof UnassignTeamMemberBody
   */
  teamMemberId: string;
}

/**
 * Check if a given object implements the UnassignTeamMemberBody interface.
 */
export function instanceOfUnassignTeamMemberBody(
  value: object,
): value is UnassignTeamMemberBody {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  return true;
}

export function UnassignTeamMemberBodyFromJSON(
  json: any,
): UnassignTeamMemberBody {
  return UnassignTeamMemberBodyFromJSONTyped(json, false);
}

export function UnassignTeamMemberBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UnassignTeamMemberBody {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    teamMemberId: json["teamMemberId"],
  };
}

export function UnassignTeamMemberBodyToJSON(
  json: any,
): UnassignTeamMemberBody {
  return UnassignTeamMemberBodyToJSONTyped(json, false);
}

export function UnassignTeamMemberBodyToJSONTyped(
  value?: UnassignTeamMemberBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    teamMemberId: value["teamMemberId"],
  };
}
